export const SET_ALL_HEALTH_TOPICS = "SET_ALL_HEALTH_TOPICS";
export const SET_ALL_ARTICLES = "SET_ALL_ARTICLES";
export const SET_UPLOAD_LINK = "SET_UPLOAD_LINK";
export const SEARCH_LOCATION_IS_AT_HOME = "SEARCH_LOCATION_IS_AT_HOME";
export const SEARCH_STRING = "SEARCH_STRING";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
